module.exports = __webpack_public_path__ + "img/highway-traffic-thumb.508c9672.jpg";